import React, { useEffect, useState } from 'react';

/** The urgency window loops every 15 minutes and the offer day flips at midnight (local time). */
const WINDOW_MINUTES = 15;

/** Polish weekday in the locative form used after "w/we" (index = Date.getDay()). */
const WEEKDAYS_PL = ['W NIEDZIELĘ', 'W PONIEDZIAŁEK', 'WE WTOREK', 'W ŚRODĘ', 'W CZWARTEK', 'W PIĄTEK', 'W SOBOTĘ'];
interface OfferState {
  weekday: string;
  minutes: string;
  seconds: string;
}
function getOfferState(): OfferState {
  const now = new Date();
  const startOfDay = new Date(now);
  startOfDay.setHours(0, 0, 0, 0);
  const secondsToday = Math.floor((now.getTime() - startOfDay.getTime()) / 1000);
  const windowSeconds = WINDOW_MINUTES * 60;
  const remaining = windowSeconds - secondsToday % windowSeconds;
  return {
    weekday: WEEKDAYS_PL[now.getDay()],
    minutes: String(Math.floor(remaining / 60)).padStart(2, '0'),
    seconds: String(remaining % 60).padStart(2, '0')
  };
}
interface TimeUnitProps {
  value: string;
  label: string;
}
function TimeUnit({
  value,
  label
}: TimeUnitProps) {
  return <div className="flex min-w-[76px] flex-col items-center" data-id="element-214" data-mp="e89w02rwd1en">
      <span className="font-display text-[52px] font-bold leading-none text-highlight sm:text-6xl" data-id="element-215" data-mp="ea331j6f9nn6">
        {value}
      </span>
      <span className="mt-2 text-[10px] font-bold tracking-[0.18em] text-white/55" data-id="element-216" data-mp="n7wy6qsgab8r">{label}</span>
    </div>;
}
export function TodayOfferCard() {
  const [offer, setOffer] = useState<OfferState>(getOfferState);
  useEffect(() => {
    const timer = window.setInterval(() => setOffer(getOfferState()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <aside aria-label="Dzisiejsza oferta" className="mt-4 overflow-hidden rounded-2xl bg-foreground px-5 py-8 text-center text-white shadow-offer sm:px-8 sm:py-10" data-id="element-217" data-mp="4hxc8crwpc9k">
      <p className="text-sm font-extrabold tracking-[0.06em] sm:text-base" data-id="element-218" data-mp="3cvnszfva9g8p">
        <span aria-hidden="true" data-id="element-219" data-mp="37y4f4h2hz5ha">⏰</span> OFERTA WAŻNA TYLKO DZIŚ{' '}
        <span className="text-highlight" data-id="element-220" data-mp="1bwarv2cqvyyw">{offer.weekday}</span>
      </p>

      <div className="mt-6 flex items-start justify-center gap-3" role="timer" aria-live="off" data-id="element-221" data-mp="1gum058ne61f0">
        <TimeUnit value={offer.minutes} label="MIN" data-id="element-222" data-mp="1llc6ao3n68ar" />
        <span className="flex flex-col items-center gap-2 pt-5" aria-hidden="true" data-id="element-223" data-mp="1llue8hzo2ayi">
          <span className="h-1.5 w-1.5 rounded-full bg-white/35" data-id="element-224" data-mp="1qjdtnl83ots1" />
          <span className="h-1.5 w-1.5 rounded-full bg-white/35" data-id="element-225" data-mp="swwvyevgge5r" />
        </span>
        <TimeUnit value={offer.seconds} label="SEK" data-id="element-226" data-mp="syzs7gn7b3ix" />
      </div>

      <p className="mt-7 text-sm font-extrabold tracking-[0.06em] text-highlight sm:text-base" data-id="element-227" data-mp="xw9rdo0e6tjy">
        SPECJALNA OFERTA NA START
      </p>
      <p className="mt-1.5 text-sm font-bold text-white sm:text-base" data-id="element-228" data-mp="16wg3p6kctnhj">
        Cena startowa obowiązuje tylko przez ograniczony czas.
      </p>

      <div className="mx-auto mt-7 max-w-sm" data-id="element-229" data-mp="2e981fodkbs5f">
        <div className="flex items-center justify-between gap-3" data-id="element-230" data-mp="2ibl76csb7q27">
          <span className="flex items-center gap-2 text-[10px] font-bold tracking-[0.12em] text-white/70" data-id="element-231" data-mp="2ia0fcuxdql81">
            <span className="h-1.5 w-1.5 rounded-full bg-highlight" aria-hidden="true" data-id="element-232" data-mp="6ngaqorg5uoz" />
            OSTATNIE MIEJSCA Z RABATEM 50%
          </span>
          <span className="text-[10px] font-bold tracking-[0.12em] text-white/85" data-id="element-233" data-mp="3u0sdnzazh7ab">
            PRAWIE KONIEC
          </span>
        </div>
        <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-white/15" role="progressbar" aria-valuenow={78} aria-valuemin={0} aria-valuemax={100} aria-label="Zajęte miejsca w cenie startowej" data-id="element-234" data-mp="3p1pjj9wjklh4">
          <div className="h-full w-[78%] rounded-full bg-highlight" data-id="element-235" data-mp="3b3hiapsh2y05" />
        </div>
        <p className="mt-2 text-[10px] font-bold tracking-[0.12em] text-white/55" data-id="element-236" data-mp="363wfu5e3g7io">
          78% MIEJSC ZAJĘTYCH
        </p>
      </div>
    </aside>;
}